import React from "react";

export const PLAN_LABEL = { pro: "Pro", business: "Business", premium: "Premium", enterprise: "Enterprise" };
export const SUB_STATUS = {
  active: ["Actif", "bg-emerald-50 text-emerald-700"],
  trialing: ["Essai", "bg-amber-50 text-amber-700"],
  past_due: ["Impayé", "bg-rose-50 text-rose-700"],
  cancelled: ["Résilié", "bg-slate-100 text-slate-500"],
  unpaid: ["Non réglé", "bg-rose-50 text-rose-700"],
};

export function eur(n) {
  if (n === null || n === undefined) return "—";
  return `${Number(n).toLocaleString("fr-FR")} €`;
}
export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
}
export function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
export function daysUntil(iso) {
  if (!iso) return null;
  return Math.ceil((new Date(iso).getTime() - Date.now()) / 86400000);
}
export function daysSince(iso) {
  if (!iso) return null;
  return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
}

export function SubStatusBadge({ status, testId }) {
  const [label, cls] = SUB_STATUS[status] || [status || "—", "bg-slate-100 text-slate-500"];
  return <span data-testid={testId} className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-medium ${cls}`}>{label}</span>;
}

export function StatCard({ icon: Icon, label, value, sub, tone = "bg-slate-100 text-slate-600", testId, onClick }) {
  const Comp = onClick ? "button" : "div";
  return (
    <Comp onClick={onClick} data-testid={testId}
      className={`flex items-center gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-left ${onClick ? "transition-colors hover:border-primary/40 hover:bg-slate-50" : ""}`}>
      {Icon && <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${tone}`}><Icon className="h-5 w-5" /></div>}
      <div className="min-w-0">
        <p className="truncate text-xl font-bold text-slate-900">{value}</p>
        <p className="text-xs text-slate-500">{label}</p>
        {sub && <p className="mt-0.5 text-[11px] font-medium text-slate-400">{sub}</p>}
      </div>
    </Comp>
  );
}

export function Delta({ current, previous }) {
  if (previous === null || previous === undefined) return null;
  const diff = current - previous;
  const cls = diff > 0 ? "text-emerald-600" : diff < 0 ? "text-rose-600" : "text-slate-400";
  const sign = diff > 0 ? "+" : "";
  return <span className={`text-[11px] font-semibold ${cls}`}>{sign}{diff} vs mois préc.</span>;
}

export function Section({ title, action, children, testId }) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={testId}>
      <div className="mb-4 flex items-center justify-between gap-2">
        <h2 className="text-sm font-bold uppercase tracking-wide text-slate-500">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
